import * as React from "react";

export interface IMapMarker {
    tooltip: string;
    classes?: string;
}

export class MapMarker extends React.Component<IMapMarker, {}> {
    render() {
        const props = this.props;
        //const coordProps: IMapCoords = props;
        return (
            <div className={"mapMarker" + (props.classes ? " " + props.classes : "")} title={props.tooltip}></div> // {...coordProps}
        );
    }
}